// redux/slices/orderApplySlice.js
import {createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const applyOrder = createAsyncThunk(
  "order/applyOrder",
  async ({ contactData, paymentOptionId }, { rejectWithValue, getState }) => {
    try {
      const token = JSON.parse(localStorage.getItem("userTools"));
      const lang = getState().i18n?.language || "en";

      // 1. Send contact info
      await axios.post(
        `${BASE_URL}/user-contact`,
        contactData,
        {
          headers: {
            Authorization: `Bearer ${token?.token}`,
            lang,
          },
        }
      );

      // 2. Send payment option ID
      const response = await axios.post(
        `${BASE_URL}/checkout/process`,
        { payment_option_id: paymentOptionId },
        {
          headers: {
            Authorization: `Bearer ${token?.token}`,
            lang,
          },
        }
      );

      return response.data?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Order application failed"
      );
    }
  }
);
